"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabBar = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importStar(require("styled-components"));
const helpers_1 = require("../helpers");
const StackView_1 = require("../StackView");
const Text_1 = require("../Text");
const Tab = styled_components_1.default.div `
    padding: 6px ${helpers_1.SPACING_L};
    cursor: pointer;

    ${({ theme, isActive }) => (0, styled_components_1.css) `
        color: ${isActive ? theme.colorTextTab : theme.colorTextTabNeighbor};
        border-bottom: ${isActive ? '4px' : '2px'} solid
            ${isActive ? theme.colorStripeAccent : theme.colorBorderMain};

        &:hover {
            background-color: ${isActive ? '#fff' : theme.colorHighlightLight};
        }

        &:active {
            background-color: ${!isActive && theme.colorHighlightDark};
        }
    `}

    ${({ isActive }) => isActive &&
    (0, styled_components_1.css) `
            cursor: default;
            padding-top: 6px;
            padding-bottom: 5px;
        `}
`;
const StyledText = (0, styled_components_1.default)(Text_1.Text) `
    text-decoration: none;
`;
exports.TabBar = (0, helpers_1.createUIElement)('TabBar', (_a, ref) => {
    var { className, items, onClick, onMouseDown, onMouseUp, onMouseEnter, onMouseLeave, onKeyDown, onKeyUp, onKeyPress, style } = _a, rest = __rest(_a, ["className", "items", "onClick", "onMouseDown", "onMouseUp", "onMouseEnter", "onMouseLeave", "onKeyDown", "onKeyUp", "onKeyPress", "style"]);
    return (react_1.default.createElement(StackView_1.StackView, Object.assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'tabbar-wrapper', className: `vm-TabBar ${className}`, direction: StackView_1.STACK_DIRECTION.row, gap: StackView_1.STACK_GAP.none, onClick: onClick, onMouseDown: onMouseDown, onMouseUp: onMouseUp, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onKeyDown: onKeyDown, onKeyUp: onKeyUp, onKeyPress: onKeyPress, ref: ref, style: style }), items.map(({ title, active, href, onClick }, idx) => {
        const WideTextProps = {};
        if (href) {
            WideTextProps.asTag = 'a';
            WideTextProps.href = href;
        }
        if (!active) {
            WideTextProps.onClick = onClick;
        }
        return (react_1.default.createElement(StyledText, Object.assign({ key: `TabBar-tab-${idx}`, "data-selector-id": `tabbar-tab-${idx + 1}`, size: Text_1.TEXT_SIZE.l }, WideTextProps),
            react_1.default.createElement(Tab, { isActive: active }, title)));
    })));
});
//# sourceMappingURL=TabBar.js.map